import { StyleRulesCallback, Theme, withStyles, WithStyles } from '@material-ui/core';
import * as React from 'react';
import { pure } from 'recompose';
import logo from 'shared/fintechone.png';
import sslimg from 'shared/ssl.png';
import LanguageSelection from './LanguageSelection';
import { BpM, BpS } from '../shared/brakepoints';
import { Languages } from '../shared/language/Language';

type CssClasses =
  | 'main'
  | 'barContainer'
  | 'logo'
  | 'logoContainer'
  | 'hr'
  | 'secureContainer'
  | 'languageContainer'
  | 'topRight'
  | 'secureImage';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  main: {
    backgroundColor: '#FFFFFF',
  },
  barContainer: {
    display: 'flex',
    padding: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit * 3,
  },
  logoContainer: {
    flex: '0 0 auto',
  },
  logo: {
    width: '180px',
    height: '32px',
    [BpM()]: {
      width: '259px',
      height: '46px',
    },
  },
  secureContainer: {
    display: 'none',
    [BpS()]: {
      display: 'block',
      paddingRight: '20px',
    },
    [BpM()]: {
      display: 'block',
      paddingRight: '40px',
    },
  },
  secureImage: {
    width: '163px',
    height: '32px',
    [BpM()]: {
      width: '250px',
      height: '49px',
    },
  },
  languageContainer: {
    [BpM()]: {
      fontSize: '17px',
      paddingRight: '20px',
    },
  },
  hr: {
    height: '2px',
    backgroundColor: theme.palette.primary.main,
  },
  topRight: {
    flex: '1 0 auto',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
});

interface Props {
  onLanguageChange: (language: Languages) => any;
}

const TopBar = ({ classes, onLanguageChange }: Props & WithStyles<CssClasses>) => (
  <div>
    <div className={classes.barContainer}>
      <div className={classes.logoContainer}>
        <img src={logo} className={classes.logo} />
      </div>
      <div className={classes.topRight}>
        <div className={classes.secureContainer}>
          <img src={sslimg} className={classes.secureImage} />
        </div>
        <div className={classes.languageContainer}>
            <LanguageSelection onLanguageChange={onLanguageChange} />
        </div>
      </div>
    </div>
    <div className={classes.hr} />
  </div>
);

export default pure(withStyles(styles)(TopBar));



// WEBPACK FOOTER //
// ./src/components/TopBar.tsx